export default "/images/arrow-down.svg?1749d0bc55a687744357f3396a5043b2";